import script from "./allwyn-heading-box.vue?vue&type=script&lang=ts&setup=true"
export * from "./allwyn-heading-box.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__